import { useEffect } from 'react';
import EVENTS from '@/utils/Constants/Events';
import { setActiveContents } from '@/utils/Controllers/TabsController';

// api
import apiSearch from '@/api/get/searchMultiResults';
import { useSearchContext } from '../../context/search';

export default () => {
  const [state, { setLoadedTab, setFilters }] = useSearchContext();
  const {
    isFirstLoad,
    activeTab,
    searchType,
    searchTerm,
    hasLoadMore,
    updateHistory,
    appliedFilter,
  } = state;
  const newUrl = `${window.location.pathname}?text=${searchTerm}&searchType=${searchType}&hasLoadMore=${hasLoadMore}`;

  useEffect(() => {
    if (!searchType || appliedFilter || isFirstLoad) return;

    const successCB = ({ filters, html } = {}) => {
      setLoadedTab(searchType);
      if (updateHistory && !isFirstLoad)
        window.history.pushState(state, null, newUrl);
      if (filters) setFilters(filters);
      DLG.EVE.emit(EVENTS.SEARCH.RESULTS.UPDATE, {
        id: activeTab.id,
        searchType,
        html,
      });
    };

    apiSearch({ searchType, searchTerm, hasLoadMore, successCB });
  }, [searchType]);

  useEffect(() => {
    if (activeTab && activeTab.isLoaded) {
      setActiveContents(activeTab.id);
    }
  }, [activeTab.id, activeTab.isLoaded]);
};
